export default {
	"问卷导航": 'Questionnaire navigation',
	"第": 'Page ',
	"页": '',
	"本页自定义逻辑编辑": 'Custom logic edit for this page',
	"页头": 'Page header',
	"产品": 'product',
	"页尾": 'End of page',
	"提示": 'Prompt',
	"当前桌号": 'Current table number',
	"位置信息": 'Position information',
	"选择日期": 'Select date',
	"选择时间": 'Select time',
	"秒": 'Second',
	"数据将不会被保存": 'Note: Currently in questionnaire testing mode, data will not be saved',
	'清除测试数据重新开始': 'Clear test data and restart',
	"问卷页": 'Questionnaire page',
	"非常不": 'Very not ',
	"非常": 'Very ',
	"文字作答": 'Text response',
	"语音作答": 'Voice response',
	"总体喜欢度": 'Overall liking',
	"肯定购买": 'Definitely will buy',
	"关键指标3": 'Key indicator 3',
	"设置": 'Settings',
	"性别": 'Gender',
	"年龄": 'Age',
	"城市": 'City',
	"产品": 'Product',
	"开放题": 'Open ended questions',
	"当前题号": 'Current question number',
	"本题自定义逻辑编辑": 'Custom logic editing for this question',
	"高级设置": 'advanced setting',
	"每一行代表一个问题答案": 'Each row represents a question/answer',
	"制表符": 'Tabs',
	"覆盖选项": 'Overwrite Options',
	"追加选项": 'Additional options',
	"分隔符": 'Delimiter',
	"无分隔符": 'No delimiter',
	"空格": 'Space',
	"逗号": 'Comma',
	"值在后": 'Value comes after label',
	"选项互斥": 'Exclusive',
	"一行显示个数": 'Number of items in one row',
	"随机选项": 'Random options',
	"实例": 'Example',
	"表示值随机": 'Indicates that options with values of 1,2,3 are randomized and separated by English commas',
	"不随机选项": 'No randomized options',
	"表示值不随机": 'Indicates that options with values of 1,2,3 are not randomized and are separated by English commas',
	"表示选项互斥": 'Indicates that option 1 or 2, option 3 or 4, and option 5 or 6 or 7 can only be selected in one set (number), where 1234567 are the values of the options',
	"全部随机": 'All random',
	"转置": 'Transpose',
	"使用下拉菜单": 'Using dropdown menus',
	"若使用下拉菜单则选项的半开放不生效": 'Note: If using a dropdown menu, the semi open option will not work',
	"答案校验": 'Verify answer',
	"答案不验证": 'Not verify answer',
	"答案验证为数字": 'Answer verified as a number',
	"答案验证为日期": 'Answer verification as a date',
	"最小值": 'Minimum value',
	"最大值": 'Maximum value',
	"值":'value',
	"唯一性": 'Uniqueness',
	"该答案在本项目唯一": 'This answer is unique in this project',
	"选项倒序": 'Options in reverse order',
	"逐一呈现": 'Display individually',
	"随机问题": 'Random problem',
	"超时记0": 'Record 0 for timeout (otherwise record based on actual click time)',
	"答案设置": 'Answer settings',
	"排序个数": 'Number of items to rank',
	"最小排序数": 'Minimum ranking number',
	"最大排序数": 'Maximum ranking number',
	"最多上传数量": 'Maximum number of uploads',
	"最少上传数量": 'Minimum number of uploads',
	"拍照上传": 'Take pictures to upload',
	"是否为视频": 'Is it a video',
	"是否为图片": 'Is it an image',
	"是否允许语音作答":'Is voice response allowed',
	"选项":'Option',
	"批量编辑修改":'Batch edit/modify',
	"列问题":'Column question',
	"行问题":'Row question',
	"问题":'Question',
	"半开放":'Semi open',
	"收藏到题库":'Save to question bank',
	"划线内容":'Underlined content',
	"不可选":'Unselectable',
	"行问题随机":'Random row problem',
	"答案必须是数字":'Answer must be a number',
	"问题管理":'Problem management',
	"问卷管理":'Questionnaire management',
	"点击获取定位":'Click to obtain location',
	"量表类型":'Scale type',
	"类型名称":'Type name',
	"选择数量":'Select num',
	"量表样式":'Scale style',
	"同一个设备只能填一次":'The same device can only be filled in once',
	"不能为空":' cannot be empty',
	"设置桌号":'Set table number',
	"开始":'Start',
	"当前桌号":'Table number',
	"有误":' is wrong',
  "选择日期":'Select date',
  "选择时间":'Select time',
  "全部":'All',
	"起始数值":'Starting value',
	"不显示数值":'Do not display numerical values',
  "显示雷达图":'Display radar map',
  "冻结题目":'Freeze question',
  "您已参与过该项目请勿重复参与":'You have already participated in this project, please do not participate again',
  "上传图片":'Upload image',
  "冻结选项":'Freeze option'
}